// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--cc446";
export var footer__bottom = "style-module--footer__bottom--72b43";
export var footer__caption = "style-module--footer__caption--bcab8";
export var footer__careers = "style-module--footer__careers--63697";
export var footer__categories = "style-module--footer__categories--caad6";
export var footer__category = "style-module--footer__category--e758a";
export var footer__copyrights = "style-module--footer__copyrights--269fc";
export var footer__formSection = "style-module--footer__form-section--68fd5";
export var footer__g2BadgeMove = "style-module--footer__g2BadgeMove--8d831";
export var footer__g2Badges = "style-module--footer__g2Badges--706fc";
export var footer__headingTopSpacing = "style-module--footer__headingTopSpacing--e7c87";
export var footer__hideForm = "style-module--footer__hideForm--5f988";
export var footer__icon = "style-module--footer__icon--34ba3";
export var footer__info = "style-module--footer__info--d960e";
export var footer__isStream = "style-module--footer__isStream--9b928";
export var footer__label = "style-module--footer__label--d97d1";
export var footer__labeltop = "style-module--footer__labeltop--14b27";
export var footer__link = "style-module--footer__link--3519e";
export var footer__links = "style-module--footer__links--ff3a2";
export var footer__logo = "style-module--footer__logo--2163a";
export var footer__mid = "style-module--footer__mid--e76f5";
export var footer__midLogo = "style-module--footer__mid-logo--f2120";
export var footer__siteInfo = "style-module--footer__siteInfo--c8622";
export var footer__socials = "style-module--footer__socials--ae497";
export var footer__subscribeFormLeft = "style-module--footer__subscribeFormLeft--1a9c8";
export var footer__subscribeFormRight = "style-module--footer__subscribeFormRight--0f92b";
export var footer__subscribeform = "style-module--footer__subscribeform--480be";
export var footer__whitetext = "style-module--footer__whitetext--ce531";
export var footer__wrapper = "style-module--footer__wrapper--163fb";
export var logoMark = "style-module--logo-mark--52059";
export var reversed = "style-module--reversed--ca6d3";